import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Box, Grid, KeyValue } from 'web-library';
import {
  AttachedFileInfo,
} from '../../../../../api/candidate/access-arrangement/model';
import DocumentBadge from '../../../../../components/DocumentBadge';
import { formatBytes } from '../../../../../utils/FileUtils';

export const useStyles = makeStyles()((theme) =>
({
  topMargin: {
    marginTop: theme.spacing(6),
  },
  documentsContainer: {
    marginTop: theme.spacing(1.5),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
}));

export interface SubmittedDetailsProps {
  documents?: AttachedFileInfo[];
}

const SubmittedDetails = ({ documents }: SubmittedDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Box className={classes.topMargin}>
      <KeyValue
        valueText={
          <Grid className={classes.documentsContainer}>
            {documents?.map((document, index) => (
              <DocumentBadge
                key={document.fileUuid}
                className={index !== 0 ? classes.documentBadgeContainer : ''}
                documentName={document.fileName}
                fileSize={formatBytes(document.fileSizeInBytes)}
              />
            ))}
          </Grid>
        }
        keyText={t('accessArrangement->>IndividualReport.SubmittedDocuments')}
      />
    </Box>
  );
};

export default SubmittedDetails;
